import { render, staticRenderFns } from "./recordsSolid.vue?vue&type=template&id=4d5e0464&scoped=true&"
import script from "./recordsSolid.vue?vue&type=script&lang=js&"
export * from "./recordsSolid.vue?vue&type=script&lang=js&"
import style0 from "./recordsSolid.vue?vue&type=style&index=0&id=4d5e0464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5e0464",
  null
  
)

export default component.exports